import type { Factura } from '../components/facturas/types';

/** Canales distintos de tienda física → prefijo WEB- (pedido web, WhatsApp, teléfono, etc.). */
export function esVentaCanalWeb(canal: Factura['canalVenta'] | undefined): boolean {
  return canal !== 'TIENDA';
}

export function prefijoNumeroPorCanal(canal: Factura['canalVenta'] | undefined): 'WEB' | 'TI' {
  return esVentaCanalWeb(canal) ? 'WEB' : 'TI';
}

/**
 * Quita cadenas WEB-/TI- repetidas al inicio (p. ej. WEB-WEB-123 → 123).
 */
export function nucleoNumeroFactura(numero: string | null | undefined): string {
  let s = (numero || '').trim();
  if (!s) return '';
  const original = s;
  while (/^(WEB-|TI-)/i.test(s)) {
    s = s.replace(/^(WEB-|TI-)/i, '').trim();
  }
  return s || original;
}

/**
 * Número coherente con el canal: siempre un solo prefijo WEB- o TI-.
 * Ej. FAC-00006 + TIENDA → TI-FAC-00006; pedido web + ONLINE → WEB-<núcleo>.
 */
export function numeroFacturaParaMostrar(
  numero: string | null | undefined,
  canalVenta: Factura['canalVenta'] | undefined
): string {
  const pref = prefijoNumeroPorCanal(canalVenta);
  const raw = (numero || '').trim();
  const core = nucleoNumeroFactura(raw);
  const cuerpo = core || raw;
  if (!cuerpo) return `${pref}-—`;
  return `${pref}-${cuerpo}`;
}

/** Borrador al abrir modal nueva factura (6 dígitos finales del timestamp). */
export function generarNumeroFacturaBorrador(canalVenta: Factura['canalVenta']): string {
  const tail = Date.now().toString().slice(-6);
  return `${prefijoNumeroPorCanal(canalVenta)}-${tail}`;
}
